import React from "react";
import Dropdown from "../DropDown";

interface CategoryDropdownProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  disabled?: boolean;
  className?: string;
  onFocus?: () => void;
}

const CategoryDropdown: React.FC<CategoryDropdownProps> = ({
  selectedCategory,
  onCategoryChange,
  disabled = false,
  className = "",
  onFocus,
}) => {
  const categoryOptions = [
    { value: "PRICING", label: "PRICING" },
    { value: "REVENUE", label: "REVENUE" },
    { value: "VOLUME", label: "VOLUME" },
    { value: "VOLUMEDELTA", label: "VOLUMEDELTA" },
    { value: "None", label: "None" },
    { value: "Status", label: "Status" },
  ];

  return (
    <Dropdown
      options={categoryOptions}
      selectedValue={selectedCategory}
      onValueChange={onCategoryChange}
      disabled={disabled}
      className={className}
      placeholder="Select Category"
      onFocus={onFocus}
    />
  );
};

export default CategoryDropdown;
